import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import useCiAdminDashboardList from './CiAdminDashboardList.hook';
import { CountWidgetPropsType } from 'components/CountWidgets/CountWidget.types';
import GridList from 'components/GridList/GridList';
import ConfirmationDialog from 'yoda-ui/components/Dialogs/ConfirmationDialog';
import Loader from 'yoda-ui/components/Loader';
import { YodaColors } from 'yoda-ui/yodaTheme';

const CiAdminDashboardList: FC<CountWidgetPropsType> = ({ filters, useAdminFilters }) => {
  const {
    customerInitiativeListColumnConfig,
    cis,
    loading,
    onPageChange,
    onPageSizeChange,
    rowCountState,
    open,
    deleteCiCallback,
    rowId,
    removeCiLoading,
    setOpen,
  } = useCiAdminDashboardList(filters, useAdminFilters);

  const { t } = useTranslation();

  return (
    <>
      <GridList
        getRowId={ (row) => row._id }
        loading={ loading }
        columnConfig={ customerInitiativeListColumnConfig }
        rows={ cis }
        onPageChange={ onPageChange }
        onPageSizeChange={ onPageSizeChange }
        rowCountState={ rowCountState }
        disableColumnMenu={ true }
        isOnDashboard={ true }
      />
      {
        open && (
          <ConfirmationDialog
            dialogTitle={ t('maya_ci_modal_remove') }
            onConfirm={
              () => {
                deleteCiCallback(rowId);
              }
            }
            onConfirmLabel={ removeCiLoading ? <Loader center size={ 1 } color={ YodaColors.inherit } /> : t('actions_confirm_label') }
            onDismiss={ () => setOpen(false) }
            onDismissLabel={ t('actions_cancel_label') }
          >
          </ConfirmationDialog>
        )
      }
    </>
  );
};

export default CiAdminDashboardList;
